import {
  LabelInput,
  EntryTypeSelect,
  DefaultValueInput,
  RequiredToggle,
  ReadOnlyToggle,
  StandardDesignConfig,
  HideOnPdfToggle,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

export const BarcodeStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  SettingsLabel('Config'), 
  DefaultValueInput,
  RequiredToggle,
  ReadOnlyToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
